module.exports = __webpack_public_path__ + "static/media/arrow-top-grey.2bf9d22f.svg";